import {MutationTree} from 'vuex'
import {IWidgetConfig, IWidgetState, WidgetState} from '../models/store-state'

export default <MutationTree<WidgetState>>{
    setConfig(state: IWidgetState, config: IWidgetConfig) {
        state.config = config
    },

    setSlidesPerView(state: WidgetState, amount: number) {
        state.slidesPerView = amount
    },

    setCurrentIndex(state: WidgetState, index: number) {
        state.currentIndex = index
    },

    setTransition(state: WidgetState, transition: string) {
        state.transition = transition
    },

    setIsHidden(state: WidgetState) {
        state.isHidden = state.config.dismissible && (localStorage?.getItem(`hide-slider-${window.location.pathname}`) === "true")
    },

    hideWidget(state: WidgetState) {
        localStorage?.setItem(`hide-slider-${window.location.pathname}`, "true")
        state.isHidden = true
    },

    toggleContent(state: WidgetState, shouldShow: boolean = true) {
        state.showContent = shouldShow
    },

    videoIsPlaying(state: WidgetState, isPlaying: boolean) {
        state.videoIsPlaying = isPlaying
    }
}